import { render, staticRenderFns } from "./CustomerDetailTop.vue?vue&type=template&id=245412d1&scoped=true&"
import script from "./CustomerDetailTop.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailTop.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailTop.vue?vue&type=style&index=0&id=245412d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245412d1",
  null
  
)

export default component.exports